import cream from './../images/Work/cream.png';
import image2 from './../images/Work/image2.png';
import image3 from './../images/Work/image3.png';
import image4 from './../images/Work/image4.png';
import image5 from './../images/Work/image5.png';
import image6 from './../images/Work/image6.png';
import image7 from './../images/Work/image7.png';
import config from './../images/Utils/config.png';

function Work() {
	return (
		<>
			<section className="bg-[#191919]">
				<section className="md:px-[40px] px-[20px] pt-[30px] font-['Lexend_Deca'] text-white">
					<header>
						<div className="flex items-center justify-between max-w-[1440px] mx-auto">
							<div className="flex w-fit items-center cursor-pointer">
								<svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path stroke-width="1" d="M20.1 10C20.1 6.19952 18.1185 2.8671 15.1467 1.02373C16.1028 0.684404 17.13 0.499999 18.2 0.499999C23.3268 0.499999 27.5 4.74372 27.5 10C27.5 15.2563 23.3268 19.5 18.2 19.5C17.13 19.5 16.1028 19.3156 15.1467 18.9763C18.1185 17.1329 20.1 13.8005 20.1 10ZM7.9 10C7.9 13.8005 9.88147 17.1329 12.8534 18.9763C11.8973 19.3156 10.87 19.5 9.8 19.5C4.67323 19.5 0.5 15.2563 0.5 10C0.499999 4.74372 4.67323 0.5 9.8 0.5C10.87 0.5 11.8972 0.684404 12.8533 1.02373C9.88147 2.8671 7.9 6.19952 7.9 10Z" stroke="#ffffff"/>
								</svg>
								<span className="font-['Lexend_Zetta'] font-semibold text-[24px] ml-[5px] tracking-[-4px]">Haptica</span>
							</div>
							<div className="font-['Lexend'] font-normal text-[14px] tracking-[3px] min-[900px]:block hidden">
								<span className="cursor-pointer hover:underline underline-offset-[5px] decoration-[2px]">WHAT WE DO</span>
								<span className="xl:mx-[100px] cursor-pointer mx-[50px] cursor-pointer hover:underline underline-offset-[5px] decoration-[2px]">OUR WORK</span>
								<span className="cursor-pointer hover:underline underline-offset-[5px] decoration-[2px]">WHY US?</span>
							</div>
							<div className="font-['Lexend'] font-normal text-[14px] tracking-[3px] flex items-center">
								<div className="sm:flex items-center hidden cursor-pointer border-b-solid hover:border-b-white border-b-[2px] border-b-[#191919]">
									<span className="mr-[5px]">CONTACT US</span>
									<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M1 9L9 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										<path d="M1 1H9V9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
									</svg>
								</div>
								<div className="min-[900px]:hidden border-[2px] border-solid p-[0.5px] rounded-[5px] border-white ml-[20px]">
									<svg className="" width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<g id="SVGRepo_bgCarrier" stroke-width="0"/>
										<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/>
										<g id="SVGRepo_iconCarrier"> <path d="M5 12H20" stroke="#ffffff" stroke-width="2" stroke-linecap="round"/> <path d="M5 17H20" stroke="#ffffff" stroke-width="2" stroke-linecap="round"/> <path d="M5 7H20" stroke="#ffffff" stroke-width="2" stroke-linecap="round"/> </g>
									</svg>
								</div>
							</div>
						</div>
					</header>
				</section>
				<section className="">
					<div className="flex items-center ml-[32%] py-[150px] overflow-hidden">
						<div className="w-fit p-[16px] rounded-[100%] bg-[#D9D9D9]"></div>
						<span className="ml-[30px] font-light text-[64px] text-white text-nowrap">Refreshing Cream's digital presence</span>
					</div>
				</section>
				<section className="md:px-[40px] px-[20px] max-w-[1210px] mx-auto">
					<img className="" src={cream} />
					<div className="text-[#6D6D6D] font-notmal font-['Lexend'] flex lg:flex-row flex-col gap-[30px] items-center justify-between max-lg:max-w-[553px] mx-auto">
						<div className="text-[18px] max-w-[553px] leading-[28px] mt-[90px]">
							<span>
								Pretium nunc nulla eu dolor pellentesque. Hendrerit tempor malesuada justo aliquet accumsan nulla arcu dolor. Tortor lorem nec ut vulputate purus quis tellus proin at. Urna diam blandit at sit pellentesque lacinia lectus rhoncus. Turpis egestas venenatis nulla bibendum.
							</span>
						</div>
						<div className="font-normal flex items-center justify-between lg:min-w-[420px] max-lg:w-full">
							<div>
								<div className="font-['Lexend_Deca'] w-fit">Client</div>
								<div className="text-white text-[18px] w-fit">Cream</div>
							</div>
							<div>
								<div className="font-['Lexend_Deca'] w-fit">Industry</div>
								<div className="text-white text-[18px] w-fit">Cosmetics</div>
							</div>
							<div>
								<div className="font-['Lexend_Deca'] w-fit">Duration</div>
								<div className="text-white text-[18px] w-fit">12 Weeks</div>
							</div>
						</div>
					</div>
				</section>

				<section className="md:px-[40px] px-[20px] max-w-[1440px] mx-auto mt-[160px] grid min-[600px]:grid-cols-2 grid-cols-1 min-[600px]:gap-[25px] gap-[100px] font-['Lexend']">
					<div className="min-[600px]:col-span-2 col-span-1">
						<img src={image2} />
					</div>
					<div>
						<img src={image3} />
						<div className="min-[600px]:mt-[90px] mt-[10px]">
							<span className="text-[#6D6D6D] text-[18px]">The logo</span>
							<div className="text-white font-['Lexend_Deca'] font-light text-[40px] leading-[48px] max-w-[493px] mt-[25px]">
								Identity of Cream's digital presence
							</div>
						</div>
					</div>
					<div>
						<img src={image4} />
						<div className="min-[600px]:mt-[90px] mt-[10px] text-[18px] leading-[28px] font-normal text-[#6D6D6D] max-w-[553px]">
							Pretium nunc nulla eu dolor pellentesque. Hendrerit tempor malesuada justo aliquet accumsan nulla arcu dolor. Tortor lorem nec ut vulputate purus quis tellus proin at. Urna diam blandit at sit pellentesque lacinia lectus rhoncus. Turpis egestas venenatis nulla bibendum.
						</div>
					</div>
				</section>

				<section className="md:px-[40px] px-[20px] max-w-[1440px] mx-auto mt-[160px] relative">
					<div className="sm:rounded-[32px] rounded-[10px] sm:p-[55px] p-[25px] bg-[#020202] grid gap-[24px] lg:grid-cols-6 sm:grid-cols-4 grid-cols-2 justify-items-center">
						<div className="col-span-2">
							<img src={image5} />
						</div>
						<div className="col-span-2">
							<img src={image6} />
						</div>
						<div className="col-span-2 lg:col-start-5 sm:col-start-2 col-start-1">
							<img src={image7} />
						</div>
					</div>
					<div className="mt-[150px] font-['Lexend_Deca'] sm:text-[40px] text-[30px] font-light leading-[56px] sm:text-right text-center text-white">
						Our other
						<br /> Interesting projects
					</div>
					<div className="sm:mt-[100px] mt-[50px] grid lg:grid-cols-6 sm:grid-cols-4 grid-cols-2 gap-[25px] flex justify-center">
						<div className="col-span-2 rounded-[40px] bg-black sm:pl-[75px] pl-[40px] pt-[40px]">
							<svg className="ml-auto mr-[40px]" width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M1 9L9 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M1 1H9V9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<div className="text-[#F7D772] font-['Leckerli_One'] text-[64px] font-normal">
								Config
							</div>
							<img src={config} className="mt-[40px] ml-auto" />
						</div>
						<div className="col-span-2 rounded-[40px] bg-[#E08686] sm:pl-[75px] pl-[40px] pt-[40px]">
							<svg className="ml-auto mr-[40px]" width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M1 9L9 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M1 1H9V9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<div className="text-[#F7D772] font-['Leckerli_One'] text-[64px] font-normal">
								Config
							</div>
							<img src={config} className="mt-[40px] ml-auto" />
						</div>
						<div className="col-span-2 max-lg:col-start-2 max-sm:col-start-1 rounded-[40px] bg-[#FFA4F0] sm:pl-[75px] pl-[40px] pt-[40px]">
							<svg className="ml-auto mr-[40px]" width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M1 9L9 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
								<path d="M1 1H9V9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</svg>
							<div className="text-[#FFFBEF] font-['Leckerli_One'] text-[64px] font-normal">
								Config
							</div>
							<img src={config} className="mt-[40px] ml-auto" />
						</div>
					</div>
					<div className="mt-[150px] max-w-[1128px] bg-black mx-auto rounded-[40px] text-white font-['Lexend_Deca'] pt-[90px] pb-[70px] min-[900px]:px-[80px] sm:px-[40px] px-[20px]">
						<div className="lg:text-[40px] sm:text-[35px] text-[25px] font-light leading-[48px]">
							Get a <span className="highlightYellow">stunning product</span> developed 
							<br className="md:block hidden" />
							<span className="md:hidden">&nbsp;</span>
							and online within the next 10 days.
						</div>
						<div className="mt-[125px] font-['Lexend_Deca'] bg-[#F2DB64] rounded-[28px] w-fit text-black py-[16px] px-[24px] cursor-pointer max-sm:mx-auto">
							Get an instant quote
						</div>
					</div>
				</section>
			</section>
			<section className="bg-[#F2DB64] mt-[-86px] rounded-t-[40px] z-[-1]">
				<div className="relative">
					<div className="max-w-[1440px] mx-auto sm:px-[40px] px-[20px] pt-[190px] pb-[150px] flex lg:flex-row flex-col justify-between items-start gap-[40px]">
						<div className="flex w-fit items-center cursor-pointer max-lg:mx-auto">
							<svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path stroke-width="1" d="M20.1 10C20.1 6.19952 18.1185 2.8671 15.1467 1.02373C16.1028 0.684404 17.13 0.499999 18.2 0.499999C23.3268 0.499999 27.5 4.74372 27.5 10C27.5 15.2563 23.3268 19.5 18.2 19.5C17.13 19.5 16.1028 19.3156 15.1467 18.9763C18.1185 17.1329 20.1 13.8005 20.1 10ZM7.9 10C7.9 13.8005 9.88147 17.1329 12.8534 18.9763C11.8973 19.3156 10.87 19.5 9.8 19.5C4.67323 19.5 0.5 15.2563 0.5 10C0.499999 4.74372 4.67323 0.5 9.8 0.5C10.87 0.5 11.8972 0.684404 12.8533 1.02373C9.88147 2.8671 7.9 6.19952 7.9 10Z" stroke="#0E071E"/>
							</svg>
							<span className="font-['Lexend_Zetta'] font-semibold text-[24px] ml-[5px] tracking-[-4px]">Haptica</span>
						</div>
						<div className="grid sm:grid-cols-3 grid-cols-2 gap-x-[50px] gap-y-[20px] tracking-[3px] text-[10px] text-left pt-[10px] mx-auto font-normal">
							<span className="cursor-pointer">WHAT WE DO</span>
							<span className="cursor-pointer">OUR WORK</span>
							<span className="cursor-pointer">WHY US?</span>
							<span className="cursor-pointer">BLOG</span>
							<span className="cursor-pointer">CUSTOMER STORIES</span>
							<span className="cursor-pointer">IN NEWS</span>
						</div>
						<div className="xl:flex hidden w-fit items-center cursor-pointer text-[#F2DB64]">
							<svg width="28" height="20" viewBox="0 0 28 20" fill="#F2DB64" xmlns="http://www.w3.org/2000/svg">
								<path stroke-width="1" d="M20.1 10C20.1 6.19952 18.1185 2.8671 15.1467 1.02373C16.1028 0.684404 17.13 0.499999 18.2 0.499999C23.3268 0.499999 27.5 4.74372 27.5 10C27.5 15.2563 23.3268 19.5 18.2 19.5C17.13 19.5 16.1028 19.3156 15.1467 18.9763C18.1185 17.1329 20.1 13.8005 20.1 10ZM7.9 10C7.9 13.8005 9.88147 17.1329 12.8534 18.9763C11.8973 19.3156 10.87 19.5 9.8 19.5C4.67323 19.5 0.5 15.2563 0.5 10C0.499999 4.74372 4.67323 0.5 9.8 0.5C10.87 0.5 11.8972 0.684404 12.8533 1.02373C9.88147 2.8671 7.9 6.19952 7.9 10Z" stroke="#F2DB64"/>
							</svg>
							<span className="font-['Lexend_Zetta'] font-semibold text-[24px] ml-[5px] tracking-[-4px]">Haptica</span>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}

export default Work;